import statusConfigItem from './statusConfigItem';
import statusActionConfig from './statusActionConfig';

export const getMenuItem = (allowedStatus, userId, statusActions, statusItem, isSelf, sortOrder, currentUserId) => {
    const configItem = statusConfigItem.get(allowedStatus);
    const action = statusActionConfig.get(configItem.get('actionKey'));
    const primaryText = configItem
        .get('nextStateLabelTemplate')
        .replace('firstWorkOrderNumber', statusItem.get('workOrderNumber') || '');

    const menuItem = {
        key: allowedStatus,
        onClick: () => action(userId, statusActions, statusItem.get('workOrderNumber'), currentUserId),
        primaryText,
        configItem,
        sortOrder
    };

    return menuItem;

};

export const getStatusItem = (userId, statusActions, statusList, isSelf, currentUserId, assignedOrderIds) => {
    const orderStatusMenuItems = [];
    const techStatusMenuItems = [];

    let currentLabel = '',
        techIsReady,
        techIsOnBreak,
        techIsEnRoute,
        techIsOnJob,
        currentIcon;

    if (!statusList || !statusList.count) {
        return { menuItems: [], label: 'Unknown' };
    }

    // A status entry's workOrderNumber can be stale (e.g. the tech's last completed/prior
    // job) if the backend hasn't cleared it yet. Only trust an in-progress (onjob/enroute)
    // entry as the tech's CURRENT job when it points at an order the tech is actually
    // assigned to right now. When assignedOrderIds isn't provided, skip the check.
    const belongsToAssignedOrder = (status) => {
        if (!assignedOrderIds) {
            return true;
        }

        const workOrderNumber = status.get('workOrderNumber');
        return !!workOrderNumber && assignedOrderIds.includes(workOrderNumber);
    };

    const readyStatus = statusList.find((status) => {
        return status.get('status') === 'ready';
    });

    const breakStatus = statusList.find((status) => {
        return status.get('status') === 'onbreak';
    });

    const enrouteStatus = statusList.find((status) => {

        return status.get('status') === 'enroute' && belongsToAssignedOrder(status);

    });

    const onJobStatus = statusList.find((status) => {

        return status.get('status') === 'onjob' && belongsToAssignedOrder(status);
    });

    const updatingStatus = statusList.find((status) => {
        return status.get('status') === 'statusupdating';
    });

    if (readyStatus) {
        techIsReady = true;
        currentLabel = statusConfigItem.getIn(['ready', 'currentLabelTemplate']);
        currentIcon = statusConfigItem.getIn(['ready', 'icon']);
    } else {
        techIsReady = false;
        currentLabel = statusConfigItem.getIn(['notready', 'currentLabelTemplate']);
        currentIcon = statusConfigItem.getIn(['notready', 'icon']);
    }

    if (enrouteStatus) {
        techIsEnRoute = true;
    }

    if (onJobStatus) {
        techIsOnJob = true;
    }

    if (breakStatus) {
        techIsOnBreak = true;
        currentLabel = statusConfigItem.getIn(['onbreak', 'currentLabelTemplate']);
        currentIcon = statusConfigItem.getIn(['onbreak', 'icon']);
    }

    if (enrouteStatus) {
        techIsReady = true;
        currentLabel = statusConfigItem
            .getIn(['enroute', 'currentLabelTemplate'])
            .replace('firstWorkOrderNumber', enrouteStatus.get('workOrderNumber') || '');

        currentIcon = statusConfigItem.getIn(['enroute', 'icon']);
    }

    if (onJobStatus) {
        techIsReady = true;
        currentLabel = statusConfigItem
            .getIn(['onjob', 'currentLabelTemplate'])
            .replace('firstWorkOrderNumber', onJobStatus.get('workOrderNumber') || '');
        currentIcon = statusConfigItem.getIn(['onjob', 'icon']);
    }

    if (updatingStatus) {
        techIsReady = true;
        currentLabel = statusConfigItem.getIn(['updatingstatus', 'currentLabelTemplate']);
        currentIcon = statusConfigItem.getIn(['updatingstatus', 'icon']);
    }

    let onBreakAdded = false,
        offbreakAdded = false,
        readyAdded = false,
        notReadyAdded = false;

    if (statusList) {
        statusList.forEach((status) => {
            status
                .get('nextAllowedStatuses')
                .forEach((allowedStatus) => {

                    if (allowedStatus === 'enroute' && !techIsEnRoute && !techIsOnJob && status.get('workOrderNumber')) {

                        orderStatusMenuItems.push(getMenuItem(allowedStatus, userId, statusActions, status, isSelf, 1, currentUserId));
                    }

                    if (allowedStatus === 'onjob' && !techIsOnJob && status.get('workOrderNumber')) {

                        orderStatusMenuItems.push(getMenuItem(allowedStatus, userId, statusActions, status, isSelf, 1, currentUserId));
                    }

                    if (allowedStatus === 'undoonjob' || allowedStatus === 'undoenroute' && status.get('workOrderNumber')) {
                        orderStatusMenuItems.push(getMenuItem(allowedStatus, userId, statusActions, status, isSelf, 2, currentUserId));
                    }

                });

            const shouldAllowReady = status
                .get('nextAllowedStatuses')
                .find((allowedStatus) => {
                    return allowedStatus === 'ready';
                });

            const shouldAllowNotReady = status
                .get('nextAllowedStatuses')
                .find((allowedStatus) => {
                    return allowedStatus === 'notready';
                });

            const shouldAllowOnBreak = status
                .get('nextAllowedStatuses')
                .find((allowedStatus) => {
                    return allowedStatus === 'onbreak';
                });

            const shouldAllowOffBreak = status
                .get('nextAllowedStatuses')
                .find((allowedStatus) => {
                    return allowedStatus === 'offbreak';
                });

            if (shouldAllowOnBreak && !onBreakAdded && !techIsOnBreak && !techIsEnRoute && !techIsOnJob) {
                techStatusMenuItems.push(getMenuItem('onbreak', userId, statusActions, status, isSelf, 1, currentUserId));
                onBreakAdded = true;
            }

            if (shouldAllowOffBreak && !offbreakAdded && techIsOnBreak) {
                techStatusMenuItems.push(getMenuItem('offbreak', userId, statusActions, status, isSelf, 1, currentUserId));
                offbreakAdded = true;
            }

            if (shouldAllowReady && !readyAdded && !techIsReady) {
                techStatusMenuItems.push(getMenuItem('ready', userId, statusActions, status, isSelf, 1, currentUserId));
                readyAdded = true;
            }

            if (shouldAllowNotReady && !notReadyAdded && techIsReady) {
                techStatusMenuItems.push(getMenuItem('notready', userId, statusActions, status, isSelf, 1, currentUserId));
                notReadyAdded = true;
            }
        });
    }
    const combinedList = orderStatusMenuItems
        .concat(techStatusMenuItems)
        .sort((a, b) => {
            if (a.sortOrder < b.sortOrder) {
                return -1;
            }

            if (a.sortOrder > b.sortOrder) {
                return 1;
            }

            return 0;
        });

    return { menuItems: combinedList, label: currentLabel, icon: currentIcon };
};

export default getStatusItem;


// WEBPACK FOOTER //
// ./src/status/statusConfig.js